import type { DicomView } from '@/modules/Editor/views/dicomView'
import { ViewTypes } from '@/modules/Editor/views/viewTypes'

export const isDicomView = (view: { type: string }): view is DicomView =>
  view.type === ViewTypes.DICOM
